<template>
  <div itemscope itemtype="https://schema.org/Article">
    <div class="bg-bg pt-24 pb-12 md:pb-24">
      <div class="container">
        <div class="-mx-24 sm:-mx-56 md:mx-auto lg:w-9/12 md:px-32">
          <nuxt-img
            :src="page.image"
            preset="standard"
            sizes="mob375:100vw mob390:100vw mob414:100vw desk:870px"
            alt="Artikelbild"
            class="w-full h-224 sm:h-410 lg:h-460 object-center object-cover"
            itemprop="image"
          />
        </div>
        <div
          class="mx-auto md:w-9/12 lg:w-7/12 md:px-4 md:px-32 mt-48"
          :class="{ '-mb-32 md:-mb-48': !page.content || !page.content.length }"
        >
          <h1 class="mb-12 text-2xl md:text-heading-xl" itemprop="name">
            {{ page.title }}
          </h1>
          <div itemprop="articleBody" v-html="page.content" />
        </div>
        <div
          v-if="articleProducts"
          class="mx-auto md:w-9/12 lg:w-7/12 md:px-4 md:px-32 mt-12"
        >
          <ArticleProducts :component="articleProducts" />
        </div>
      </div>
    </div>
    <div v-if="articlePage.components.length > 0">
      <component
        :is="BlockComponents[component.layout]"
        v-for="(component, idx) in articlePage.components"
        :key="component.layout + idx"
        v-bind="{ component }"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import Page from '~/models/page';
import BlockComponents from '~/constants/block-components';
import ComponentBlock from '~/models/component-block';
import ArticleProducts from '~/components/blocks/ArticleProducts.vue';

const props = defineProps<{
  page: any,
}>();

const articlePage = computed(()=> {
  return new Page({ contentData: props.page });
});

const articleProducts = computed(()=> {
  if ( props.page.article_products[0]) {
    const component = {
      products: props.page.article_products[0].products,
    } as any;
    return new ComponentBlock(component);
  }
  return false;
});

</script>

<style scoped lang="postcss">
</style>
